import { Autocomplete, TextField } from '@mui/material';
import { useAdapterConfigLabels } from '../../hooks/useAdapterServices';

const ALL_LABELS_VALUE = '';

const DEFAULT_HELPER_TEXT =
  'Filter vendors by label; same label is used when syncing adapter config';

type Props = {
  value: string;
  onChange: (label: string) => void;
  /** When false, omit inline helper text (e.g. when parent renders a shared caption). */
  showHelperText?: boolean;
  size?: 'small' | 'medium';
};

/** Provider list: empty value = all vendors (any resolved label). */
export function ProviderListLabelFilter({
  value,
  onChange,
  showHelperText = true,
  size = 'medium',
}: Props) {
  const { data: labels = ['default'], isLoading } = useAdapterConfigLabels();
  const options = [ALL_LABELS_VALUE, ...labels];
  const displayValue = value || ALL_LABELS_VALUE;

  return (
    <Autocomplete
      disableClearable
      fullWidth
      size={size}
      loading={isLoading}
      options={options}
      value={displayValue}
      getOptionLabel={option => (option === ALL_LABELS_VALUE ? 'All labels' : option)}
      onChange={(_, v) => onChange(v === ALL_LABELS_VALUE ? '' : (v ?? '').trim() || '')}
      renderInput={params => (
        <TextField
          {...params}
          size={size}
          label="Adapter config label"
          required
          helperText={showHelperText ? DEFAULT_HELPER_TEXT : undefined}
        />
      )}
    />
  );
}
